import script from "./EarnPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./EarnPoints.vue?vue&type=script&setup=true&lang=js"

import "./EarnPoints.vue?vue&type=style&index=0&id=02112ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02112ff8"]])

export default __exports__